import Vue from 'vue';
import Vuex from 'vuex';

import i18n from './modules/i18n';
import user from './modules/user';

import api from '../api';

import { FETCH_FEATURES } from './actions';
import { SET_FEATURES } from './mutations';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
    modules: {
        i18n,
        user
    },

    strict: debug,

    state: {
        features: {
            vkAuth: true
        }
    },

    actions: {
        async [FETCH_FEATURES](context) {
            let response = await api.get('/app/features');

            if (response && response.data)
                context.commit(SET_FEATURES, response.data);
        }
    },

    mutations: {
        [SET_FEATURES](state, features) {
            state.features = features;
        }
    },

    getters: {
        features(state) {
            return state.features;
        }
    }
});
